import styled from 'styled-components';

export const containerShowDataOnlyList = styled.div`
	width: 100%;
`;
